type Context = 'supabase';

type Section = 'addon-credit-plan' | 'customer-info' | 'downloads' | 'signals';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  'addon-credit-plan': 'supabase-addon-credit-plan',
  'customer-info': 'supabase-customer-info',
  downloads: 'supabase-downloads',
  signals: 'supabase-signals',
};
